
























import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import MemberBeneficiariesItem from "@/components/dashboard/find-member-or-employer/tabs/MemberBeneficiariesItem.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {MemberPlan} from "@/models/MemberPlan";
import Component from 'vue-class-component'
import {Prop} from "vue-property-decorator";
import {Action} from "vuex-class";

@Component({
  components: {
    MemberBeneficiariesItem
  }
})
export default class MemberBeneficiaries extends AfterFetchComponent {

  @Action('getMemberBeneficiaries', StoreNamespace.CUSTOMER_SERVICE) getMemberBeneficiaries: any;

  @Prop() memberIdNum!: string

  memberPlanList: MemberPlan[] = []
  showNoDataMessage: boolean = false;


  mounted() {
    this.getMemberBeneficiaries({
      requestorCallback: this,
      requestBody: {
        memberIdType: '1',
        memberIdNumber: this.getMemberIdNum
      }
    })
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'findMembersOrEmployersFor/getMemberBeneficiaries':
        if (data.length > 0) {
          this.showNoDataMessage = false
          this.memberPlanList = data;
        } else {
          this.showNoDataMessage = true
        }
        break;
    }
  }

  get getMemberIdNum() {
    return this.memberIdNum + ''
  }
}
